<template>
  <div style="height: 100%;">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../../echarts/bar.vue'
export default {
  data () {
    return {
      cdata: {
        category: [
        "高寒草甸类",
            "高寒草原类",
            "高寒荒漠类",
            "温性典型草原类",
            "温性荒漠类",
            "低地草甸类",
            "山地草甸类"
        ],
        lineData: [
        0, 0, 0, 78162.58, 0, 21563.16, 0
        ],
        title:"草原类",
        yAxisUnit:"万亩",
        rateData: []
      }
    };
  },
  components: {
    Chart,
  },
  mounted () {
    this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData () {
      
    },
  }
};
</script>

<style lang="scss" scoped>
</style>